import React from "react";

import Joi from "joi-browser";
import Form from "../common/Form";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import { PopUpContext } from "../../contexts/popUpContext";

class StaffContractForm extends Form {
  static contextType = PopUpContext;

  state = {
    drp: {
    },
    data: {
      salary_per_month: "",
      contract_start_date: "",
      contract_end_date: "",
    },
    errors: {},
  };

  componentDidMount = async () => {
    const { drp, data } = this.state;
    const {
      popUp: { cache, edit },
    } = this.context;

    if (edit) {
      data.salary_per_month = edit.salary_per_month;
      data.contract_start_date = edit.contract_start_date;
      data.contract_end_date = edit.contract_end_date;
    }

    this.setState({ drp, data });
  };

  schema = {
    salary_per_month: Joi.number(),
    contract_start_date: Joi.string(),
    contract_end_date: Joi.string(),
  };

  doSubmit = async (e) => {
    const { togglePopUp, popUp } = this.context;

    console.log(popUp)
    let __controls = this.cleanObject({
      staff: popUp?.cache ? popUp?.cache : popUp?.edit?.staff,
      ...this.state.data,
    });

    try {
      if (popUp?.edit) {
        await db
            .edit(`staff/contracts/${popUp?.edit?.salary_id}`, __controls)
            .then(() => {
              togglePopUp({ form: "toast" });
            })
            .catch((err) => {
              togglePopUp({
                form: "toast",
                message: err.toString(),
                type: "warning",
              });
            });
      } else {
        await db
            .save("staff/contracts", __controls)
            .then(() => {
              togglePopUp({ form: "toast" });
            })
            .catch((err) => {
              togglePopUp({
                form: "toast",
                message: err.toString(),
                type: "warning",
              });
            });
      }
      if (popUp.callback) popUp.callback();
    } catch ({ response }) {
      if (response && response.status === 400) {
        const errors = { ...this.state.error };

        this.setState({ errors });
      }
    }
  };

  render() {
    const { data, drp } = this.state;
    const { popUp } = this.context;

    return (
      <div className="form-container">
        <form className="form crud" onSubmit={this.handleSubmit}>
          <div className="head">
            <p>{popUp?.edit ? lbl.EditContract : lbl.AddContract}</p>
          </div>
          <div className="form-inputs">
            {this.renderInput("salary_per_month", "معاش ماهانه", "number")}
            {this.renderInput("contract_start_date", "تاریخ شروع", "date")}
            {this.renderInput("contract_end_date", "تاریخ ختم", "date")}
          </div>
          <div className="form-buttons">
            {this.renderButton(popUp?.edit ? lbl.Edit : lbl.Save)}
          </div>
        </form>
      </div>
    );
  }
}

export default StaffContractForm;
